
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/media-coverage",
      function () {
        return require("private-next-pages/[company]/media-coverage.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company]/media-coverage"])
      });
    }
  